import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

interface QRCodeDisplayProps {
  url: string;
  size?: number;
  className?: string;
  alt?: string;
  /** Rendered when QR fails or URL is empty */
  fallback?: React.ReactNode;
}

/** Client-side QR code generation - no backend dependency */
function QRCodeDisplay({ url, size = 400, className = '', alt = 'QR Code', fallback }: QRCodeDisplayProps) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!url) {
      setDataUrl(null);
      setError(null);
      return;
    }
    setError(null);
    QRCode.toDataURL(url, {
      width: size,
      margin: 2,
      color: { dark: '#000000', light: '#FFFFFF' },
      errorCorrectionLevel: 'M',
    })
      .then(setDataUrl)
      .catch((err: unknown) => {
        console.error('QR generation failed:', err);
        setError(err instanceof Error ? err.message : 'Failed to generate QR');
      });
  }, [url, size]);

  if (!url || error) return <>{fallback}</>;
  if (!dataUrl) return <>{fallback}</>;
  return <img src={dataUrl} alt={alt} className={className} />;
}

export default QRCodeDisplay;
